import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { BodyActualizacionLead } from 'src/app/interfaces/body_actualizacion_lead';
import { BodyInquilino } from 'src/app/interfaces/bodyInquilino';
import { ResponseDatosActualizacionLead } from 'src/app/interfaces/response_datos_actualizacion_lead';
import { CiudadesModels } from 'src/app/models/ciudades';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { MENSAJE_PROPIETARIO, TIEMPO_INACTIVO } from 'src/app/routes.constants';
import { CiudadesService } from 'src/app/services/cuidades/ciudades.service';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-datos-inquilino',
  standalone: false,
  templateUrl: './datos-inquilino.component.html',
  styleUrl: './datos-inquilino.component.scss'
})
export class DatosInquilinoComponent implements OnInit {

  @ViewChild('primerNombre') primerNombre!: ElementRef;
  @ViewChild('numCelular') numCelular!: ElementRef;
  @ViewChild('correo') correoElec!: ElementRef;


  public modelSalida!: NgbDateStruct;
  public modelRegreso!: NgbDateStruct;
  parametro: string = '';
  emailPattern = environment.PATTERN_EMAIL;
  celularPattern = environment.PATTERN_CELULAR;
  identPatter = environment.PATTERN_IDENTIFICACION
  json: string = '';
  jsonFinal: string = '';
  mensajeAlerta: string = '';
  swAlerta: boolean = false;
  minutos: number = 0;
  segundos: number = 0;
  id: any;
  swHabilitaBoton: boolean = false;
  dato1: string = '';
  dato2: string = '';
  dato3: string = '';
  dato4: string = '';
  completo: string[] = [];
  nombrePantalla: string = '';
  planSeleccionado: string = '';
  ngSelect = "CO";
  ngSelectTI: string = 'C';
  swLlenaDatos: boolean = false;
  states: string[] = [];
  ciudades: CiudadesModels[] = [];
  ciudadSeleccionada: string = '';
  sessionId: string = '';
  editable: boolean = true;
  today = new Date();
  pipe = new DatePipe('en-US');
  fechaActual = this.pipe.transform(this.today, 'dd/MM/YYYY')

  // Tiempo local de renovación 
  localTimer = environment.LOCAL_TIMER;
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  // Intervalo para detectar movimiento del cursor
  isMouseMove: any;
  checador: any;
  saliendo: boolean = false;
  leadId: string = '';
  codAsesor: string = '';
  responseActualizacion!: ResponseDatosActualizacionLead;
  IdBitacora: string = '';

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
    this.isActivity = true;
    nuevaPosicionX = e.clientX;
    nuevaPosicionY = e.clientY;

    if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
      clearTimeout(this.checador);
      this.checador = setTimeout(() => {
        console.log('Mouse inactivo');
        if (this.saliendo == false) {
          this.isActivity = false;
          this.saliendo = true;
          clearInterval(this.isMouseMove);
          clearTimeout(this.checador);

          this.datosGenerales.Inquilino.primerNombre = this.formulario.get("primerNombre")?.value.split(' ')[0];
          this.datosGenerales.Inquilino.numCelular = this.formulario.get("numCelular")?.value.toString();
          this.datosGenerales.Inquilino.correo = this.formulario.get("correo")?.value;
          this.parametro = JSON.stringify(this.datosGenerales);

          this.router.navigate([TIEMPO_INACTIVO, { codigoAsesor: this.codAsesor, idLead: this.leadId, porcPll: '40', msnPll: 'Tiempo inactivo_datos inquilino', infoViaje: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
        }
      }, this.localTimer);
    }

    posicionX = e.clientX;
    posicionY = e.clientY;
  }

  regExp = RegExp(this.celularPattern);
  regExpIdent = RegExp(this.identPatter);
  regExpTextos = RegExp('[a-z, ñÑ, íÍ, óÓ, áÁ, éÉ, úÚ]');

  formulario: FormGroup = new FormGroup(
    {
      primerNombre: new FormControl('', [Validators.required]),
      numCelular: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]),
      correo: new FormControl('', [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]),
      flexCheckAutoriza: new FormControl(false, Validators.requiredTrue)

    }
  );

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  datosEnvio: BodyInquilino = {

    SessionId: '',
    leadId: '',
    asesorCode: '',
    bitacoraId: '',
    productFamily: '',
    screenPercentage: '',

    productsConfigurationData: {
      ProductCode: '',
      PolicyHolder: {
        LastName: '',
        CountryOfBirth: '',
        DocumentNumber: '',
        DocumentType: '',
        ExpeditionDate: '',
        FirstName: '',
        Mail: '',
        MobilePhone: '',
        PersonalDataAuthorization: false,
        PersonalDataLastUpdated: '',
        PersonalDataVersion: '',
        SecondLastName: '',
        SecondName: ''
      },
      Property: {
        AdministrationValue: 0,
        ContractStartDate: '',
        Department: '',
        RentalFee: 0,
        TemporaryContracted: '',
        UseProperty: '',
        CityProperty: '',
        RealEstateLicensePlate: '',
        PropertyAddress: '',
        // new atrivutes for Property
        Code: '',
        CityCode: '',
        DepartmentCode: '',

      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: '',
        PersonalDataVersion: '',
        PersonalDataLastUpdated: '',
        PersonalDataAuthorization: false,
        MobilePhone: '',
        Mail: '',
        ExpeditionDate: '',
        CountryOfBirth: '',
        SecondLastName: '',
        LastName: '',
        SecondName: '',
        FirstName: ''
      }
    }
  };

  datosActualizacionLead: BodyActualizacionLead = {
    SessionId: '',
    leadId: '',
    asesorCode: '',
    bitacoraId: '',
    productFamily: '',
    createQuote: false,
    screenPercentage: '',

    responseDataRiesgoConsultable: [],
    productsConfigurationData: {
      ProductCode: '',
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false,
        PersonalDataVersion: '',
        PersonalDataLastUpdated: '',
        FirstName: '',
        Mail: '',
        ExpeditionDate: '',
        DocumentNumber: '',
        DocumentType: '',
        CountryOfBirth: '',
        SecondLastName: '',
        SecondName: ''
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: '',
        PersonalDataVersion: '',
        PersonalDataLastUpdated: '',
        PersonalDataAuthorization: false,
        MobilePhone: '',
        Mail: '',
        ExpeditionDate: '',
        CountryOfBirth: '',
        SecondLastName: '',
        LastName: '',
        SecondName: '',
        FirstName: ''
      },
      Property: {
        TemporaryContracted: '',
        ContractStartDate: '',
        CityProperty: '',
        RealEstateLicensePlate: '',
        PropertyAddress: '',
        AdministrationValue: 0,
        RentalFee: 0,
        Department: '',
        UseProperty: '',
        Code: '',
        CityCode: '',
        DepartmentCode: ''


      }
    }
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _dataLayerService: DataLayerService,
    private orquestadorService: OrquestadorService
  ) {
    this.minutos = 0;
    this.segundos = 8;
  }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  @Input() infoCliente?: string;
  @Input() idLead?: string;
  @Input() codigoAsesor?: string = '';
  @Input() bitacoraId: string = '';

  ngOnInit(): void {
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    console.log('DATOS INQUILINO');
    this.localTimer = environment.LOCAL_TIMER;
    this.sessionId = this.getLocalStorage().toString();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);
        this.formulario.get("documentoIdentidad")?.setValue(this.datosGenerales.Cliente.cedulaCliente);
      }
      else {
        const paramInfoCliente = this.infoCliente;
        const paramIdLead = this.idLead;
        this.leadId = paramIdLead !== undefined ? paramIdLead : '';
        this.codAsesor = this.codigoAsesor !== undefined ? this.codigoAsesor : '';
        this.IdBitacora = this.bitacoraId !== undefined ? this.bitacoraId : '';

        if (paramInfoCliente !== undefined) {
          this.json = paramInfoCliente;
          this.jsonFinal = atob(this.json);
          this.datosGenerales = JSON.parse(this.jsonFinal);

          this.formulario.get("primerNombre")?.setValue(this.datosGenerales.Inquilino.primerNombre);
          this.formulario.get("numCelular")?.setValue(this.datosGenerales.Inquilino.numCelular);
          this.formulario.get("correo")?.setValue(this.datosGenerales.Inquilino.correo);
        }
      }
    });
  }

  ngOnDestroy() {
    this.saliendo = true;
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    if (this.checador) {
      clearInterval(this.checador);
    }
  }

  valPrimerNombre = false;
  valPrimerNombre2 = true;
  validacionPrimerNombre() {
    if (this.formulario.get("primerNombre")?.value === '') {
      this.valPrimerNombre = !this.valPrimerNombre;
      this.valPrimerNombre2 = !this.valPrimerNombre2;
    } else if (!this.regExpTextos.test(this.formulario.get("primerNombre")?.value)) {
      this.valPrimerNombre = !this.valPrimerNombre;
      this.valPrimerNombre2 = !this.valPrimerNombre2;
    } else {
      this.valPrimerNombre = false;
      this.valPrimerNombre2 = true;
    }
  }

  valPrimerApellido = false;
  valPrimerApellido2 = true;
  validacionPrimerApellido() {
    if (this.formulario.get("primerApellido")?.value === '') {
      this.valPrimerApellido = !this.valPrimerApellido;
      this.valPrimerApellido2 = !this.valPrimerApellido2;
    } else if (!this.regExpTextos.test(this.formulario.get("primerApellido")?.value)) {
      this.valPrimerApellido = !this.valPrimerApellido;
      this.valPrimerApellido2 = !this.valPrimerApellido2;
    } else {
      this.valPrimerApellido = false;
      this.valPrimerApellido2 = true;
    }
  }

  valCelular = false;
  valCelular2 = true;
  validacionCelular() {
    if (this.formulario.get("numCelular")?.value === '') {
      this.valCelular = !this.valCelular;
      this.valCelular2 = !this.valCelular2;
    } else if (!this.regExp.test(this.formulario.get("numCelular")?.value)) {
      this.valCelular = !this.valCelular;
      this.valCelular2 = !this.valCelular2;
    } else {
      this.valCelular = false;
      this.valCelular2 = true;
    }
  }

  valEmail = false;
  valEmail2 = true;
  validacionEmail() {
    if (this.formulario.get("correo")?.value === '') {
      this.valEmail = !this.valEmail;
      this.valEmail2 = !this.valEmail2;
    } else {
      this.valEmail = false;
      this.valEmail2 = true;
    }
  }

  valpaisNacimento = false;
  valpaisNacimento2 = true;
  validacionPaisNacimento() {
    if (this.formulario.get("paisNacimento")?.value === '') {
      this.valpaisNacimento = !this.valpaisNacimento;
      this.valpaisNacimento2 = !this.valpaisNacimento2;
    } else {
      this.valpaisNacimento = false;
      this.valpaisNacimento2 = true;
    }
  }

  valTipoDocumentoIdentidad = false;
  valTipoDocumentoIdentidad2 = true;
  validacionTipoDocumentoIdentidad() {
    if (this.formulario.get("tipoidentificacion")?.value === '') {
      this.valTipoDocumentoIdentidad = !this.valTipoDocumentoIdentidad;
      this.valTipoDocumentoIdentidad2 = !this.valTipoDocumentoIdentidad2;
    } else {
      this.valTipoDocumentoIdentidad = false;
      this.valTipoDocumentoIdentidad2 = true;
    }
  }


  prueba: string = ''
  valdDocumentoIdentidad = false;
  valdDocumentoIdentidad2 = true;
  validacionDocumentoIdentidad() {
    if (this.formulario.get("documentoIdentidad")?.value === '') {
      this.valdDocumentoIdentidad = !this.valdDocumentoIdentidad;
      this.valdDocumentoIdentidad2 = !this.valdDocumentoIdentidad2;
    } else if (!this.regExpIdent.test(this.formulario.get("documentoIdentidad")?.value)) {
      this.valdDocumentoIdentidad = !this.valdDocumentoIdentidad;
      this.valdDocumentoIdentidad2 = !this.valdDocumentoIdentidad2;
    }
    else {
      this.valdDocumentoIdentidad = false;
      this.valdDocumentoIdentidad2 = true;
    }
  }

  private convertirObjectFechaToString(objeto: AbstractControl): string {
    let fecha = objeto.value.toString().split("-");
    if (fecha !== null) {
      let año = fecha[0];
      let mes = fecha[1];
      let dia = fecha[2];
      return (dia + "/" + mes + "/" + año);
    }
    else {
      return ''
    }
  }


  valFechaExpedicion = false;
  valFechaExpedicion2 = true;
  validacioneFechaExpedicion() {
    if (this.formulario.get("fechaExpedicion")?.value !== undefined) {
      this.valFechaExpedicion = false;
      this.valFechaExpedicion2 = true;

      const fechaExpedicion = this.convertirObjectFechaToString(this.formulario.get("fechaExpedicion")!);
      var seleccionada = moment(fechaExpedicion, "DD/MM/YYYY");
      var factual = moment(this.fechaActual, "DD/MM/YYYY");

      if (seleccionada.isAfter(factual)) {
        Swal.fire('La fecha de expedición del documento no puede ser mayor a la fecha actual.', '', 'warning');
        this.formulario.get("fechaExpedicion")?.setValue('');
        return;
      }
    }
    else {
      this.valFechaExpedicion = !this.valFechaExpedicion;
      this.valFechaExpedicion2 = !this.valFechaExpedicion2;
    }
  }

  get nombrePrimerNoValido() {
    return this.formulario.get("primerNombre")?.invalid
      && this.formulario.get("primerNombre")?.touched;
  }

  get primerApellidoNoValido() {
    return this.formulario.get("primerApellido")?.invalid
      && this.formulario.get("primerApellido")?.touched;
  }

  get correoNoValido() {
    return this.formulario.get("correo")?.invalid
      && this.formulario.get("correo")?.touched;
  }

  get cedularNoValido() {
    if (this.formulario.get("numCelular")?.value !== '') {
      if (!this.regExp.test(this.formulario.get("numCelular")?.value)) {
        if (this.valCelular) {
          return false
        }
        return true;
      }
    }
    return false;
  }

  get paisNacimientoNoValido() {
    if (this.formulario.get("paisNacimento")?.value === ''
      && this.formulario.get("paisNacimento")?.touched) {
      return true;
    }
    return false;
  }

  get tipoidentificacionNoValido() {
    if (this.formulario.get("tipoidentificacion")?.value === ''
      && this.formulario.get("tipoidentificacion")?.touched) {
      return true;
    }
    return false;
  }

  get fechaExpedicionNoValido() {
    if (this.formulario.get("fechaExpedicion")?.value === undefined
      && this.formulario.get("fechaExpedicion")?.touched) {
      return true;
    }
    return false;
  }

  get documentoNoValido() {
    if (this.formulario.get("documentoIdentidad")?.value !== '') {
      if (!this.regExpIdent.test(this.formulario.get("documentoIdentidad")?.value)) {
        if (this.valdDocumentoIdentidad) {
          return false
        }
        return true;
      }
    }
    return false;
  }

  get formularioNoValido() {
    return this.formulario.invalid
  }

  private convertirFechaReemplazar(objeto: string): string {
    let fecha = objeto.split("/");
    if (fecha !== null) {
      let año = fecha[2];
      let mes = fecha[1];
      let dia = fecha[0];
      return (año + "-" + mes + "-" + dia);
    }
    else {
      return ''
    }
  }

  Validaciones() {
    this.datosGenerales.Inquilino.primerNombre = this.formulario.get("primerNombre")?.value.split(' ')[0];
    this.datosGenerales.Inquilino.numCelular = this.formulario.get("numCelular")?.value;
    this.datosGenerales.Inquilino.correo = this.formulario.get("correo")?.value;
    this.parametro = JSON.stringify(this.datosGenerales);

    this._dataLayerService.logDatos('ecommerce_step_7', 'Arrendamiento', 'Datos inquilino',
      this.sessionId, this.datosGenerales.InfoArrendamiento.valorArriendo.toString(),
      this.datosGenerales.InfoArrendamiento.valorAdministracion.toString(),
      this.datosGenerales.InfoArrendamiento.tipoPropiedad,
      this.datosGenerales.InfoArrendamiento.ubicacion, this.datosGenerales.InfoArrendamiento.ubicacion,
      this.datosGenerales.InfoArrendamiento.duracionContrato,
      this.datosGenerales.InfoArrendamiento.fechaContrato, this.datosGenerales.PlanSeleccionado.plan,
      this.datosGenerales.PlanSeleccionado.valorPlan.toString(),
      this.datosGenerales.InfoArrendamiento.ServiciosPublicos ? 'true' : 'false',
      this.datosGenerales.InfoArrendamiento.PaquetesAsistencia ? 'true' : 'false',
      this.datosGenerales.Inquilino.paisNacimento, this.datosGenerales.Inmueble.maticula);


    this.GuardarDataLayer();
    this.router.navigate([MENSAJE_PROPIETARIO, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro) }]);
  }

  private GuardarDataLayer() {
    console.log('DATOS INQUILINO Guardar');
    const datepipe: DatePipe = new DatePipe('en-US')
    let formattedDate = datepipe.transform(Date.now(), 'dd/MM/YYYY');

    this.datosEnvio.SessionId = this.sessionId;
    this.datosEnvio.leadId = this.leadId;

    if (this.codAsesor === 'undefined') {
      this.codAsesor = '';
      this.datosEnvio.asesorCode = this.codAsesor;
    }

    if (this.codAsesor != '') {
      this.datosEnvio.asesorCode = this.codAsesor;
    }
    else {
      this.datosEnvio.asesorCode = this.codAsesor;
    }

    this.datosEnvio.bitacoraId = this.IdBitacora;
    this.datosEnvio.productFamily = 'Arrendamientos'
    this.datosEnvio.screenPercentage = '40';



    this.datosEnvio.productsConfigurationData.ProductCode = this.datosGenerales.PlanSeleccionado.plan
    this.datosEnvio.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Propietario.primerApellido;
    this.datosEnvio.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
    this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
    this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataVersion = this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataVersion == '' ? (formattedDate === null ? '' : formattedDate) : this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataVersion;
    this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataLastUpdated = formattedDate === null ? '' : formattedDate;
    this.datosEnvio.productsConfigurationData.PolicyHolder.FirstName = this.datosGenerales.Propietario.primerNombre;
    this.datosEnvio.productsConfigurationData.PolicyHolder.Mail = this.datosGenerales.Propietario.correo;
    this.datosEnvio.productsConfigurationData.PolicyHolder.ExpeditionDate = this.datosGenerales.Propietario.fechaExpedicion;
    this.datosEnvio.productsConfigurationData.PolicyHolder.DocumentNumber = this.datosGenerales.Propietario.numeroIdentificacion.toString();
    this.datosEnvio.productsConfigurationData.PolicyHolder.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
    this.datosEnvio.productsConfigurationData.PolicyHolder.CountryOfBirth = this.datosGenerales.Propietario.paisNacimiento;
    this.datosEnvio.productsConfigurationData.PolicyHolder.SecondLastName = this.datosGenerales.Propietario.segundoApellido;
    this.datosEnvio.productsConfigurationData.PolicyHolder.SecondName = this.datosGenerales.Propietario.segundoNombre;

    this.datosEnvio.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
    this.datosEnvio.productsConfigurationData.Tenant.DocumentType = 'C';
    this.datosEnvio.productsConfigurationData.Tenant.PersonalDataVersion = this.datosEnvio.productsConfigurationData.Tenant.PersonalDataVersion == '' ? (formattedDate === null ? '' : formattedDate) : this.datosEnvio.productsConfigurationData.Tenant.PersonalDataVersion;
    this.datosEnvio.productsConfigurationData.Tenant.PersonalDataLastUpdated = formattedDate === null ? '' : formattedDate;
    this.datosEnvio.productsConfigurationData.Tenant.PersonalDataAuthorization = true;
    this.datosEnvio.productsConfigurationData.Tenant.MobilePhone = this.datosGenerales.Inquilino.numCelular.toString();
    this.datosEnvio.productsConfigurationData.Tenant.Mail = this.datosGenerales.Inquilino.correo;
    this.datosEnvio.productsConfigurationData.Tenant.ExpeditionDate = '';
    this.datosEnvio.productsConfigurationData.Tenant.CountryOfBirth = 'Colombia';
    this.datosEnvio.productsConfigurationData.Tenant.SecondLastName = '';
    this.datosEnvio.productsConfigurationData.Tenant.LastName = '';
    this.datosEnvio.productsConfigurationData.Tenant.SecondName = '';
    this.datosEnvio.productsConfigurationData.Tenant.FirstName = this.datosGenerales.Inquilino.primerNombre.split(' ')[0];

    this.datosEnvio.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.datosEnvio.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.datosEnvio.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
    this.datosEnvio.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
    this.datosEnvio.productsConfigurationData.Property.ContractStartDate = this.datosGenerales.InfoArrendamiento.fechaContrato;
    this.datosEnvio.productsConfigurationData.Property.CityProperty = this.datosGenerales.Inmueble.ciudad;
    this.datosEnvio.productsConfigurationData.Property.RealEstateLicensePlate = this.datosGenerales.Inmueble.maticula;
    this.datosEnvio.productsConfigurationData.Property.PropertyAddress = this.datosGenerales.Inmueble.direccion;
    this.datosEnvio.productsConfigurationData.Property.TemporaryContracted = this.datosGenerales.InfoArrendamiento.duracionContrato;
    this.datosEnvio.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
    this.datosEnvio.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
    this.datosEnvio.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;

    console.log('Datos de envío preparados - ID:', Date.now());



    // probando este agregfa  
    if (this.datosGenerales.PlanSeleccionado.plan === 'Arma tu plan') {
      this.datosEnvio.optionalProducts = {
        PRD_CoveragePublicServices: this.datosGenerales.InfoArrendamiento.ServiciosPublicos ? 'true' : 'false',
        PRD_CoverageAsistence: this.datosGenerales.InfoArrendamiento.PaquetesAsistencia ? 'true' : 'false',
      };
    }

    this.orquestadorService.postOrquestadorDatosInquilino(this.datosEnvio).
      subscribe(
        (data) => {
          if (data != undefined) {
            this.ActualizarLead();
          }
        }
      );
  }

  private ActualizarLead() {
    const datepipe: DatePipe = new DatePipe('en-US')
    let formattedDate = datepipe.transform(Date.now(), 'dd/MM/YYYY');

    this.datosActualizacionLead.SessionId = this.sessionId;
    this.datosActualizacionLead.leadId = this.leadId;
    this.datosActualizacionLead.screenPercentage = '40';

    if (this.codAsesor != "0") {
      this.datosActualizacionLead.asesorCode = this.codAsesor;
    }

    this.datosActualizacionLead.bitacoraId = this.IdBitacora;
    this.datosActualizacionLead.productFamily = 'Arrendamientos';
    this.datosActualizacionLead.createQuote = true;

    this.datosGenerales.ResponseRiesgoConsultable.forEach(element => {
      this.datosActualizacionLead.responseDataRiesgoConsultable.push(
        {
          esRiesgo: element.esRiesgo,
          tipoValidacion: element.tipoValidacion,
          mensajeValidacion: element.mensajeValidacion,
          idRegistroValidacion: element.idRegistroValidacion
        }
      );
    });

    this.datosActualizacionLead.productsConfigurationData.ProductCode = this.datosGenerales.PlanSeleccionado.plan
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Propietario.primerApellido;
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente;
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.PersonalDataVersion = this.datosActualizacionLead.productsConfigurationData.PolicyHolder.PersonalDataVersion == '' ? (formattedDate === null ? '' : formattedDate) : this.datosActualizacionLead.productsConfigurationData.PolicyHolder.PersonalDataVersion;
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.PersonalDataLastUpdated = formattedDate === null ? '' : formattedDate;
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.FirstName = this.datosGenerales.Propietario.primerNombre;
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.Mail = this.datosGenerales.Propietario.correo;
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.ExpeditionDate = this.datosGenerales.Propietario.fechaExpedicion;
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.DocumentNumber = this.datosGenerales.Propietario.numeroIdentificacion.toString();
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.CountryOfBirth = this.datosGenerales.Propietario.paisNacimiento;
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.SecondLastName = this.datosGenerales.Propietario.segundoApellido;
    this.datosActualizacionLead.productsConfigurationData.PolicyHolder.SecondName = this.datosGenerales.Propietario.segundoNombre;
    this.datosActualizacionLead.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
    this.datosActualizacionLead.productsConfigurationData.Tenant.DocumentType = 'C';
    this.datosActualizacionLead.productsConfigurationData.Tenant.PersonalDataVersion = this.datosActualizacionLead.productsConfigurationData.Tenant.PersonalDataVersion == '' ? (formattedDate === null ? '' : formattedDate) : this.datosActualizacionLead.productsConfigurationData.Tenant.PersonalDataVersion;
    this.datosActualizacionLead.productsConfigurationData.Tenant.PersonalDataLastUpdated = formattedDate === null ? '' : formattedDate;
    this.datosActualizacionLead.productsConfigurationData.Tenant.PersonalDataAuthorization = true;
    this.datosActualizacionLead.productsConfigurationData.Tenant.MobilePhone = this.datosGenerales.Inquilino.numCelular;
    this.datosActualizacionLead.productsConfigurationData.Tenant.Mail = this.datosGenerales.Inquilino.correo;
    this.datosActualizacionLead.productsConfigurationData.Tenant.ExpeditionDate = '';
    this.datosActualizacionLead.productsConfigurationData.Tenant.CountryOfBirth = 'Colombia';
    this.datosActualizacionLead.productsConfigurationData.Tenant.SecondLastName = '';
    this.datosActualizacionLead.productsConfigurationData.Tenant.LastName = '';
    this.datosActualizacionLead.productsConfigurationData.Tenant.SecondName = '';
    this.datosActualizacionLead.productsConfigurationData.Tenant.FirstName = this.datosGenerales.Inquilino.primerNombre.split(' ')[0];
    this.datosActualizacionLead.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.datosActualizacionLead.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.datosActualizacionLead.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
    this.datosActualizacionLead.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
    this.datosActualizacionLead.productsConfigurationData.Property.ContractStartDate = this.datosGenerales.InfoArrendamiento.fechaContrato;
    this.datosActualizacionLead.productsConfigurationData.Property.TemporaryContracted = this.datosGenerales.InfoArrendamiento.duracionContrato;
    this.datosActualizacionLead.productsConfigurationData.Property.CityProperty = this.datosGenerales.Inmueble.ciudad;
    this.datosActualizacionLead.productsConfigurationData.Property.RealEstateLicensePlate = this.datosGenerales.Inmueble.maticula;
    this.datosActualizacionLead.productsConfigurationData.Property.PropertyAddress = this.datosGenerales.Inmueble.direccion;
    this.datosActualizacionLead.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
    this.datosActualizacionLead.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
    this.datosActualizacionLead.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;


    if (this.datosGenerales.PlanSeleccionado.plan === 'Arma tu plan') {
      this.datosActualizacionLead.optionalProducts = {
        PRD_CoveragePublicServices: this.datosGenerales.InfoArrendamiento.ServiciosPublicos ? 'true' : 'false',
        PRD_CoverageAsistence: this.datosGenerales.InfoArrendamiento.PaquetesAsistencia ? 'true' : 'false',
      };
    }


    this.orquestadorService.postOrquestadorActualizacionLead(this.datosActualizacionLead).
      subscribe(
        (data) => {
          this.responseActualizacion = data;
        }
      );
  }


}
